import container from 'modules/section-content';
import page from 'page';
import domify from 'domify';
import React from 'react';
import { throttle } from 'lodash';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm, PricingPlans } from 'components';
import PricingScripts from 'components/pricingPlans/vendor/index';
import abTesting from 'modules/ab-testing';
import lottie from 'lottie-web';
import inView from 'in-view';
import splash from './view/main.pug';
import metadata from './metadata.json';
import animationFunnel from './animations/funnel/data.json';
import animationPhone from './animations/phone/data.json';

const pricingScripts = new PricingScripts();
const metricsLib = window.metricsLib;

export default function register() {
  page(
    '/b2b-enterprise-identity-management',
    render,
    renderPricingPlans,
    pricingScripts.loadScripts,
    pricingScripts.renderPricing,
    pricingScripts.renderFeatures,
    pricingScripts.snippets,
    snippets
  );
  page.exit('/b2b-enterprise-identity-management', unMountApp);
}

function renderPricingPlans(ctx, next) {
  abTesting.executeExperiment('show-pricing-plans', variant => {
    if (variant && variant.name === 'show-pricing-plans') {
      clientRender(
        <PricingPlans btnFooterText="SEE MORE PRICING INFO" />,
        document.querySelector('.solution-page-pricing-plans')
      );
    }
  });

  return next();
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm source="b2b" subject="New lead from B2B page" />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  contactFormModals();
  initAnimation();
  return next();
}

function unMountApp(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  unmountComponentAtNode(document.querySelector('.solution-page-pricing-plans'));
  return next();
}

function initAnimation() {
  const containerFunnel = document.getElementById('animation-funnel');
  const containerPhone = document.getElementById('animation-phone');

  const params1 = {
    container: containerFunnel,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: animationFunnel
  };

  const params2 = {
    container: containerPhone,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: animationPhone
  };

  const animFunnel = lottie.loadAnimation(params1);
  const animPhone = lottie.loadAnimation(params2);

  const funnelPlayState = false;
  const phonePlayState = false;

  inView.threshold(0.5);

  const playAnimationsIfVisible = throttle(() => {
    if (!funnelPlayState && inView.is(containerFunnel)) {
      animFunnel.play();
    }
    if (!phonePlayState && inView.is(containerPhone)) {
      animPhone.play();
    }
  }, 300);

  playAnimationsIfVisible();

  document.addEventListener('scroll', playAnimationsIfVisible);
}

function contactFormModals() {
  // Contact Sales Form
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2b-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2b-contact-form', metricsData);
    },
    source: 'b2b-page'
  };

  document.querySelectorAll('.open-contact-form-modal').forEach(element => {
    element.addEventListener(
      'click',
      () => {
        const salesContactForm = new ContactForm(salesContactFormOptions);
        salesContactForm.show({ includePhoneField: true });
      },
      false
    );
  });
}



// WEBPACK FOOTER //
// ./src/pages/b2b/b2b.js